import axios from "axios";

interface FeedgetConfig {
  apiKey: string;
  apiUrl?: string;
  metadata?: {
    userId?: string;
    version?: string;
    custom?: Record<string, any>;
  };
}

interface FeedbackData {
  type: "BUG" | "IDEA" | "OTHER";
  comment: string;
  screenshot?: string;
  metadata?: {
    url?: string;
    userAgent?: string;
    viewport?: { width: number; height: number };
    custom?: Record<string, any>;
  };
}

class FeedgetAPI {
  private apiKey: string;
  private baseURL: string;
  private globalMetadata: FeedgetConfig["metadata"];

  constructor(config: FeedgetConfig) {
    this.apiKey = config.apiKey;
    this.baseURL = config.apiUrl || "https://api.feedget.io";
    this.globalMetadata = config.metadata;
  }

  private getMetadata() {
    return {
      url: window.location.href,
      userAgent: navigator.userAgent,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
      custom: this.globalMetadata,
    };
  }

  async submitFeedback(data: Omit<FeedbackData, "metadata">) {
    const api = axios.create({
      baseURL: this.baseURL,
      headers: {
        "X-API-Key": this.apiKey,
        "Content-Type": "application/json",
      },
    });

    const payload: FeedbackData = {
      ...data,
      metadata: this.getMetadata(),
    };

    return api.post("/public/feedbacks", payload);
  }

  async healthCheck() {
    const api = axios.create({
      baseURL: this.baseURL,
      headers: {
        "X-API-Key": this.apiKey,
      },
    });

    return api.get("/public/health");
  }
}

// Instância global que será configurada
let feedgetInstance: FeedgetAPI | null = null;

export const initFeedget = (config: FeedgetConfig) => {
  feedgetInstance = new FeedgetAPI(config);
  return feedgetInstance;
};

export const getFeedgetInstance = () => {
  if (!feedgetInstance) {
    throw new Error("Feedget not initialized. Call initFeedget() first.");
  }
  return feedgetInstance;
};

// Manter compatibilidade com a implementação existente
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "https://api.feedget.io",
});

export default api;
